// LIVE-EGRESS-AUDIO-FIX-1 · RoomComposite 템플릿 원격 트랙 연결 (영상 → <video muted>, 음성 → 숨김 <audio>).
export function attachRemoteTrack(track, { videoEl, audioContainer, kinds }) {
  if (!track) return null;
  if (track.kind === kinds.Video) {
    if (videoEl) track.attach(videoEl);
    return videoEl || null;
  }
  if (track.kind === kinds.Audio) {
    if (!audioContainer) return null;
    const el = track.attach();
    el.autoplay = true;
    el.setAttribute('data-testid', 'egress-template-audio');
    audioContainer.appendChild(el);
    return el;
  }
  return null;
}

export function detachRemoteTrack(track) {
  if (!track) return;
  const els = track.detach() || [];
  els.forEach((el) => {
    if (el && el.tagName === 'AUDIO' && el.parentNode) el.parentNode.removeChild(el);
  });
}
